import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask'
})
export class PhoneMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      value = value.replace(/\D/g, '');
      if(value.length >= 10) {
        var phone: Array<any> = [];
        phone.push(value.slice(0, 2));
        if(value.length === 10) {
          phone.push(value.slice(2,6));
          phone.push(value.slice(6,10));
        } else {
          phone.push(value.slice(2,7));
          phone.push(value.slice(7,11));
        }

        value = '(' + phone[0] + ') ' + phone[1] + '-' + phone[2];
      }
      return value;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/phone-mask.pipe.ts
 **/